import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandListPage_DeleteBrand($brandId: Int!) {
    deleteBrand(brandId: $brandId) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useDeleteBrandMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['brandId'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (brandId) =>
      graphQLRequest({ document, variables: { brandId } }),
    ...options,
  })
}
